import { CreditUsage } from '@aibees/shared/features/credit-usage';
import { Card, CardHeader, Typography } from '@mui/material';

export function CreditUsageView() {
  return (
    <Card variant="outlined" headerDivider>
      <CardHeader
        title={
          <Typography variant="body1" fontWeight={700} color="grey.700">
            Credit Usage
          </Typography>
        }
      />

      <CreditUsage />
    </Card>
  );
}
